import { backendClient } from "@/lib/backend-api";
import { safe } from "@orpc/client";
import { useQuery } from "@tanstack/react-query";

export const useMembers = () => {
  return useQuery({
    queryKey: ["members"],
    queryFn: () => {
      return safe(backendClient.shop.listMembers());
    },
  });
};
